import classNames from "classnames";
import { type Control, Controller } from "react-hook-form";
import { CustomFormFieldWrapper } from "../../../../../../BuildingBlocks/Forms/MantineFormFields/CustomFormFieldWrapper/CustomFormFieldWrapper";
import type { ChangeableFieldErrors } from "../../../../../../ChangeableFieldWidget/ChangeableFieldTable/ChangeableFieldTable";
import { DELIVERY_FORM_HELP_TEXTS } from "../../DeliveryForm.constants";
import type { DeliveryFormFields } from "../../DeliveryForm.types";
import { ChangeableSpotMarketFormulaFieldStatic } from "./ChangeableSpotMarketFormulaFieldStatic/ChangeableSpotMarketFormulaFieldStatic";

interface ChangeableSpotMarketFieldProps {
  control: Control<DeliveryFormFields>;
  errors?: ChangeableFieldErrors;
  name: keyof Pick<DeliveryFormFields, "spotMarketPrices">;
  label: string;
  unit: string;
  className?: string;
  allowInput?: boolean;
  collapsible?: boolean;
}

function ChangeableSpotMarketField({
  control,
  errors,
  name,
  label,
  unit,
  className,
  allowInput = true,
  collapsible = true
}: ChangeableSpotMarketFieldProps) {
  return (
    <CustomFormFieldWrapper
      className={classNames("ChangeableSpotMarketField", className)}
      helpText={DELIVERY_FORM_HELP_TEXTS.spotMarketPrices}
      label={label}
      name={name}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <ChangeableSpotMarketFormulaFieldStatic
            {...field}
            allowInput={allowInput}
            collapsible={collapsible}
            errors={errors}
            fieldName={field.name}
            unit={unit}
            onInput={(_, value) => field.onChange(value)}
          />
        )}
      />
    </CustomFormFieldWrapper>
  );
}

export { ChangeableSpotMarketField };
